import { useCallback, useEffect, useState } from "react";

function useScroll(scrollContainer: HTMLElement | null) {
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = useCallback(
    (scrollElem: HTMLElement) => () => {
      if (scrollElem.scrollTop > 0) {
        if (!isScrolled) {
          setIsScrolled(true);
        }
      } else {
        if (isScrolled) {
          setIsScrolled(false);
        }
      }
    },
    [isScrolled]
  );

  useEffect(() => {
    if (!scrollContainer) {
      return;
    }
    const onScroll = handleScroll(scrollContainer);
    scrollContainer.addEventListener("scroll", onScroll, {
      passive: true,
    });
    return () => {
      scrollContainer.removeEventListener("scroll", onScroll);
    };
  }, [handleScroll, scrollContainer]);

  return { isScrolled };
}

export default useScroll;
